module.exports = __webpack_public_path__ + "static/undraw_programming_2svr-97cd896250fb49641b88a7c0c272044e.svg";